import { sendGodotMessage, GODOT_MESSAGE } from "app/godot-embed/godot-bridge";
import IconClockwise from "app/icons/IconClockwise";
import IconCounterclockwise from "app/icons/IconCounterclockwise";
import HudButton from "app/ui/HudButton";
import { useEffect, useState } from "react";
import cn from "app/util/classnames";

const ICON_SIZE = 24;

interface RotateButtonProps {
  disabled?: boolean;
}

export default function RotateButton(props: RotateButtonProps) {
  const [isRotated, setIsRotated] = useState(false);

  // Grid automatically unrotates whenever the player zooms out
  useEffect(() => {
    if (props.disabled) {
      setIsRotated(false);
    }
  }, [props.disabled]);

  function handleHudButtonClick() {
    // TODO: make sure button doesn't go out of sync with game
    sendGodotMessage(GODOT_MESSAGE.TOGGLE_ROTATE);
    setIsRotated(!isRotated);
  }

  return (
    <div className="flex flex-col items-center p-1 pr-1.5">
      <HudButton onClick={handleHudButtonClick} disabled={props.disabled}>
        {isRotated ? (
          <IconCounterclockwise width={ICON_SIZE} height={ICON_SIZE} />
        ) : (
          <IconClockwise width={ICON_SIZE} height={ICON_SIZE} />
        )}
      </HudButton>
      <p // Button label
        className={cn(
          "uppercase text-xs",
          props.disabled
            ? "opacity-50"
            : "opacity-100",
        )}
      >
        Rotate
      </p>
    </div>
  );
}
